import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { BffCartAddress } from '@/core/models/bff-shopping-carts';
import { putBffShoppingCartBillingAddress } from '@/core/services/fetchers';

export const MUTATION_KEY = ['bff-update-cart-billing-address'];

type Variables = {
  address: BffCartAddress;
};

async function mutationFn(params: {
  cartId: string;
  languageCode: string;
  address: BffCartAddress;
}): Promise<void> {
  await putBffShoppingCartBillingAddress({
    cartId: params.cartId,
    languageCode: params.languageCode,
    address: params.address,
  });
}

const useBffUpdateCartBillingAddressMutation = (
  {
    cartId,
    languageCode,
  }: {
    cartId: string | null;
    languageCode: string;
  },
  options?: Omit<
    UseMutationOptions<void, Error, Variables>,
    'mutationKey' | 'mutationFn'
  >,
) =>
  useMutation({
    ...options,
    mutationKey: [...MUTATION_KEY, cartId, languageCode],
    mutationFn: (variables: Variables) => {
      if (!cartId) {
        throw new Error('Invalid cart ID');
      }
      return mutationFn({
        cartId,
        languageCode,
        address: variables.address,
      });
    },
  });

export default useBffUpdateCartBillingAddressMutation;
